<script setup>
import {ref, watch} from 'vue';
import BaseSelectContainerStyle1 from "@/components/forms/BaseSelectContainerStyle1.vue";

const props = defineProps({
  modelValue: String,
});

const emits = defineEmits(['update:modelValue']);

const localValue = ref(props.modelValue);

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue);
});

watch(() => props.modelValue, (newValue) => {
  localValue.value = newValue;
});
</script>

<template>
   <BaseSelectContainerStyle1
    v-model="localValue"
    :options="[
      { 'value': 'american', 'label': 'American' },
      { 'value': 'decimal', 'label': 'Decimal' },
      { 'value': 'fractional', 'label': 'Fractional' }
    ]"
    label="Odds Type:"
  />
</template>
